import { logoutUser } from '../actions'
import { tokenRefresh } from '../actions/token_refresh'
import { __isEnvDev, ACTION_LOCATION_CHANGE, STORAGE_TYPE_LOCAL, TRACKED_ACTIONS } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'
import { isTimeToRefreshToken, isTokenExist, isTokenExpired } from '../utils/session'
import { API_JWT_TOKEN_IAT, API_JWT_TOKEN_NAME } from './api'

const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)

const tokenRefreshMiddleware = (store) => (next) => (action) => {
  if (typeof action === 'undefined') {
    return
  }
  if (action.type === ACTION_LOCATION_CHANGE || TRACKED_ACTIONS.includes(action.type)) {
    if (isTokenExist() && isTokenExpired()) {
      store.dispatch(logoutUser())
    } else {
      if (!isTokenExpired() && isTimeToRefreshToken()) {
        next(action)
        return Promise.resolve(store.dispatch(tokenRefresh()))
          .then((data) => {
            storageProvider.setItem(API_JWT_TOKEN_NAME, data.response.access)
            storageProvider.setItem(API_JWT_TOKEN_IAT, Math.round(Date.now() / 1000).toString())
            if (__isEnvDev()) {
              console.log('Access token renewed')
            }
          })
          .catch((reason) => {
            if (__isEnvDev()) {
              console.log('Error encountered while trying to refresh token %s', reason)
            }
          })
      }
    }
  }
  if (typeof action.then !== 'function') {
    return next(action)
  }
}

export default tokenRefreshMiddleware
